import {
  required,
  minLength,
  sameAs,
  maxLength,
  requiredIf,
  email,
  helpers,
  maxValue,
  minValue,
} from "vuelidate/lib/validators";

export default {
  required,
  minLength,
  maxLength,
  sameAs,
  requiredIf,
  email,
  helpers,
  maxValue,
  minValue,
};
